import dynamic from "next/dynamic";
const MediaImage = dynamic(() => import("components/templates/media/media--image").then((mod) => mod.MediaImage));
const FormattedText = dynamic(() => import("components/formatted-text").then((mod) => mod.FormattedText));

export function NodeBasicPage({ node, ...props }) {
  return (
    <article className="container px-6 lg:px-0 py-10 mx-auto" {...props}>
      {node.field_page_image && (
        <div className="my-6 overflow-hidden rounded-md">
          <MediaImage
            media={node.field_page_image}
            priority
            sizes="(min-width: 768px) 625px, 100vw"
          />
        </div>
      )}
      <h1 className="mb-4 leading-tight">
        {node.title}
      </h1>
      {node.body?.processed && (
        <div className="prose">
          <FormattedText processed={node.body.processed} />
        </div>
      )}
    </article>
  );
}
